var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 48,
    viewBox: "0 0 166 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.908 47.3325H6.12123C2.76145 47.3325 0.00976562 44.6729 0.00976562 41.4255V5.98369C0.00976562 2.73633 2.76145 0.0767107 6.12123 0.0767107H158.908C162.268 0.0767107 165.019 2.73633 165.019 5.98369V41.4255C165.019 44.6729 162.268 47.3325 158.908 47.3325Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.908 1.0233C161.738 1.0233 164.04 3.24876 164.04 5.98369V41.4255C164.04 44.1605 161.738 46.3859 158.908 46.3859H6.12123C3.29162 46.3859 0.989128 44.1605 0.989128 41.4255V5.98369C0.989128 3.24876 3.29162 1.0233 6.12123 1.0233H158.908ZM158.908 0.0767107H6.12123C2.76145 0.0767107 0.00976562 2.73633 0.00976562 5.98369V41.4255C0.00976562 44.6729 2.76145 47.3325 6.12123 47.3325H158.908C162.268 47.3325 165.019 44.6729 165.019 41.4255V5.98369C165.019 2.73633 162.268 0.0767107 158.908 0.0767107Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.968 12.1787C57.968 13.1651 57.6624 13.9552 57.0604 14.5444C56.3682 15.2429 55.4667 15.5944 54.3619 15.5944C53.3061 15.5944 52.4046 15.237 51.665 14.5326C50.924 13.8178 50.5542 12.9407 50.5542 11.8907C50.5542 10.8407 50.924 9.96354 51.665 9.2547C52.4046 8.54438 53.3061 8.18701 54.3619 8.18701C54.8876 8.18701 55.3887 8.29186 55.867 8.48679C56.3437 8.6832 56.7318 8.94901 57.013 9.27685L56.3743 9.90004C55.8838 9.34035 55.2161 9.0642 54.3619 9.0642C53.5918 9.0642 52.9241 9.32411 52.3572 9.84835C51.7965 10.3741 51.5153 11.0549 51.5153 11.8907C51.5153 12.7265 51.7965 13.4132 52.3572 13.9389C52.9241 14.4573 53.5918 14.7231 54.3619 14.7231C55.1794 14.7231 55.867 14.4573 56.4094 13.933C56.767 13.586 56.9702 13.1075 57.0237 12.4962H54.3619V11.6426H57.913C57.9558 11.8272 57.968 12.0059 57.968 12.1787Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6017 9.21917H60.2653V11.4638H63.2731V12.3174H60.2653V14.562H63.6017V15.4318H59.3208V8.34937H63.6017V9.21917Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.576 15.4318H66.6318V9.21917H64.5859V8.34937H69.6233V9.21917H67.576V15.4318Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2688 15.4318V8.34937H74.2106V15.4318H73.2688Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3902 15.4318H77.4536V9.21917H75.4001V8.34937H80.4436V9.21917H78.3902V15.4318Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9808 14.5208C89.258 15.237 88.3626 15.5944 87.2946 15.5944C86.2204 15.5944 85.325 15.237 84.6023 14.5208C83.8811 13.806 83.522 12.9288 83.522 11.8907C83.522 10.8525 83.8811 9.97535 84.6023 9.26061C85.325 8.54438 86.2204 8.18701 87.2946 8.18701C88.3565 8.18701 89.2519 8.54438 89.9747 9.26651C90.702 9.98716 91.0611 10.8584 91.0611 11.8907C91.0611 12.9288 90.702 13.806 89.9808 14.5208ZM85.3006 13.9271C85.8445 14.4573 86.5061 14.7231 87.2946 14.7231C88.0769 14.7231 88.7446 14.4573 89.2825 13.9271C89.8249 13.397 90.0999 12.7162 90.0999 11.8907C90.0999 11.0652 89.8249 10.3844 89.2825 9.85426C88.7446 9.32411 88.0769 9.05829 87.2946 9.05829C86.5061 9.05829 85.8445 9.32411 85.3006 9.85426C84.7581 10.3844 84.4831 11.0652 84.4831 11.8907C84.4831 12.7162 84.7581 13.397 85.3006 13.9271Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3855 15.4318V8.34937H93.5314L97.0944 13.8576H97.1356L97.0944 12.4961V8.34937H98.0371V15.4318H97.0531L93.3221 9.65185H93.2808L93.3221 11.0193V15.4318H92.3855Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2899 25.775C80.419 25.775 78.0738 27.8867 78.0738 30.8004C78.0738 33.6903 80.419 35.8242 83.2899 35.8242C86.1669 35.8242 88.5122 33.6903 88.5122 30.8004C88.5122 27.8867 86.1669 25.775 83.2899 25.775ZM83.2899 33.8454C81.7147 33.8454 80.3595 32.5887 80.3595 30.8004C80.3595 28.9884 81.7147 27.7538 83.2899 27.7538C84.8651 27.7538 86.2265 28.9884 86.2265 30.8004C86.2265 32.5887 84.8651 33.8454 83.2899 33.8454ZM71.9088 25.775C69.0319 25.775 66.6927 27.8867 66.6927 30.8004C66.6927 33.6903 69.0319 35.8242 71.9088 35.8242C74.7843 35.8242 77.125 33.6903 77.125 30.8004C77.125 27.8867 74.7843 25.775 71.9088 25.775ZM71.9088 33.8454C70.3321 33.8454 68.9723 32.5887 68.9723 30.8004C68.9723 28.9884 70.3321 27.7538 71.9088 27.7538C73.4841 27.7538 74.8393 28.9884 74.8393 30.8004C74.8393 32.5887 73.4841 33.8454 71.9088 33.8454ZM58.3658 27.3152V29.4506H63.6415C63.4872 30.6438 63.0747 31.521 62.4422 32.1324C61.6721 32.8708 60.4728 33.6903 58.3658 33.6903C55.1191 33.6903 52.5767 31.1577 52.5767 28.0197C52.5767 24.8816 55.1191 22.349 58.3658 22.349C60.1213 22.349 61.3986 23.012 62.3413 23.8715L63.8982 22.3667C62.5797 21.1498 60.8257 20.2151 58.3658 20.2151C53.9136 20.2151 50.1719 23.7164 50.1719 28.0197C50.1719 32.3229 53.9136 35.8242 58.3658 35.8242C60.7722 35.8242 62.5797 35.0622 64.0006 33.6328C65.4567 32.2254 65.9104 30.2466 65.9104 28.6487C65.9104 28.1526 65.8676 27.6962 65.7913 27.3152H58.3658ZM113.745 28.9707C113.316 27.8469 111.991 25.775 109.293 25.775C106.619 25.775 104.393 27.8114 104.393 30.8004C104.393 33.615 106.596 35.8242 109.549 35.8242C111.937 35.8242 113.316 34.4169 113.882 33.5973L112.11 32.4558C111.519 33.2916 110.714 33.8454 109.549 33.8454C108.393 33.8454 107.563 33.333 107.031 32.3229L113.985 29.5422L113.745 28.9707ZM106.656 30.6438C106.596 28.7063 108.212 27.714 109.371 27.714C110.278 27.714 111.048 28.1526 111.305 28.7802L106.656 30.6438ZM101.004 35.5186H103.29V20.7511H101.004V35.5186ZM97.2607 26.8944H97.1843C96.671 26.3066 95.6916 25.775 94.451 25.775C91.8475 25.775 89.4671 27.9842 89.4671 30.8166C89.4671 33.6328 91.8475 35.8242 94.451 35.8242C95.6916 35.8242 96.671 35.2882 97.1843 34.6827H97.2607V35.4034C97.2607 37.3246 96.1989 38.3569 94.4861 38.3569C93.0896 38.3569 92.2234 37.3822 91.8658 36.5626L89.8781 37.3645C90.451 38.6965 91.9682 40.3357 94.4861 40.3357C97.166 40.3357 99.4272 38.8117 99.4272 35.1036V26.0807H97.2607V26.8944ZM94.6465 33.8454C93.0713 33.8454 91.7528 32.571 91.7528 30.8166C91.7528 29.046 93.0713 27.7538 94.6465 27.7538C96.1989 27.7538 97.4227 29.046 97.4227 30.8166C97.4227 32.571 96.1989 33.8454 94.6465 33.8454ZM124.446 20.7511H118.979V35.5186H121.259V29.9232H124.446C126.978 29.9232 129.461 28.1526 129.461 25.3364C129.461 22.5217 126.972 20.7511 124.446 20.7511ZM124.506 27.869H121.259V22.8053H124.506C126.208 22.8053 127.179 24.1713 127.179 25.3364C127.179 26.4794 126.208 27.869 124.506 27.869ZM138.597 25.7469C136.95 25.7469 135.237 26.4499 134.533 28.0078L136.556 28.8274C136.991 28.0078 137.792 27.742 138.638 27.742C139.821 27.742 141.02 28.4287 141.039 29.6411V29.7962C140.626 29.5658 139.743 29.2247 138.657 29.2247C136.478 29.2247 134.258 30.3839 134.258 32.5473C134.258 34.5262 136.043 35.8006 138.049 35.8006C139.583 35.8006 140.429 35.1316 140.961 34.3534H141.039V35.4949H143.24V29.8301C143.24 27.2119 141.217 25.7469 138.597 25.7469ZM138.322 33.8395C137.577 33.8395 136.538 33.4821 136.538 32.5887C136.538 31.4457 137.833 31.0071 138.955 31.0071C139.958 31.0071 140.429 31.2212 141.039 31.5033C140.86 32.8708 139.642 33.8395 138.322 33.8395ZM151.262 26.0703L148.641 32.472H148.563L145.855 26.0703H143.396L147.466 35.0165L145.144 39.9946H147.526L153.798 26.0703H151.262ZM130.713 35.5186H132.999V20.7511H130.713V35.5186Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7643 8.98297C12.4053 9.34625 12.1975 9.91184 12.1975 10.6443V36.7709C12.1975 37.5033 12.4053 38.0689 12.7643 38.4322L12.853 38.512L28.0002 23.8774V23.5319L12.853 8.89732L12.7643 8.98297Z",
    fill: "url(#paint0_linear_6292_95461)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.043 28.7578L27.9995 23.8772V23.5316L33.0491 18.651L33.1622 18.7145L39.1422 22.0032C40.8489 22.9365 40.8489 24.4723 39.1422 25.4115L33.1622 28.6943L33.043 28.7578Z",
    fill: "url(#paint1_linear_6292_95461)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1622 28.6948L27.9996 23.7048L12.7637 38.4324C13.3305 39.0083 14.2549 39.0778 15.306 38.5018L33.1622 28.6948Z",
    fill: "url(#paint2_linear_6292_95461)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1622 18.7147L15.306 8.90761C14.2549 8.33759 13.3305 8.40699 12.7637 8.98292L27.9996 23.7046L33.1622 18.7147Z",
    fill: "url(#paint3_linear_6292_95461)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6292_95461",
    x1: 26.6553,
    y1: 37.043,
    x2: 6.84016,
    y2: 16.5418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6292_95461",
    x1: 41.3646,
    y1: 23.7027,
    x2: 11.7888,
    y2: 23.7027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6292_95461",
    x1: 30.3549,
    y1: 20.9922,
    x2: 3.48392,
    y2: -6.80898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6292_95461",
    x1: 8.92848,
    y1: 47.1243,
    x2: 20.9276,
    y2: 34.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.cc174fb7af01a6753ecd82e7581b8390.svg";
export { ForwardRef as ReactComponent };